import styled from '@emotion/styled'

export const PageWrapper = styled.div`
  display: flex;
  gap: 1.25rem;
  width: 100%;
  justify-content: center;
`
export const EditPageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 1.25rem;
`
